import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useLocation, Link } from "react-router-dom";
import { ReactComponent as BudgetIcon } from '../../../assets/budgeticon-white.svg';
import { ReactComponent as HomeIcon } from '../../../assets/home-icon.svg';
import '../../navbar/itinerary-nav/ItineraryNav.css';


const BudgetNav = () => {
    const { trip_id } = useParams();
    const [trip, setTrip] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const fetchTrip = async () => {
            try {
                const response = await axios.get(`/trip/${trip_id}`);
                setTrip(response.data);
            } catch (error) {
                console.error("Error fetching trip data:", error);
            }
        };

        fetchTrip();
    }, [trip_id]); 

    if (!trip) return <div>Loading...</div>; 

    const isBudgetPage = location.pathname.startsWith("/budget-saved/");

    return (
        <nav className="itinerary-nav">
            <h1>{trip.TRIP_NAME}</h1>  
            <ul>
                <li className="homenav-header">
                    <Link to="/" className={location.pathname === "/" ? "nav-link active" : "nav-link"}>
                        <HomeIcon className="homenav-icon" />
                        Home
                    </Link>
                </li>
                <li className="itinerarynav-header">
                    <Link
                        to={`/budget-saved/${trip.TRIP_ID}`} 
                        className={isBudgetPage ? "nav-link active" : "nav-link"}
                    >
                        <BudgetIcon className="homenav-icon" />
                        Budget
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default BudgetNav;